<template>
  <div class="nav-header-web">
    <div class="header">
      <div class="content">
        <div>
          <img class="logo-img" src="../assets/new-logo.png" />
        </div>
        <div class="header-des">{{ $t("future") }}</div>
      </div>
      <div>
        <Button type="text" class="enquiry" @click="modal11 = true">
          {{ $t("enquiry") }}
        </Button>
        <Button type="text" class="lang-btn" @click="handleSwitch">
          ENGLISH
        </Button>
      </div>
    </div>
    <div class="menu content">
      <Menu mode="horizontal" :theme="theme1" active-name="1">
        <MenuItem name="1" to="/">
          <span
            @click="handleClickLinkHome"
            :class="{
              active: activeShow.home,
              unactive: !activeShow.home,
            }"
            >{{ $t("nav.Home") }}</span
          >
        </MenuItem>
        <Submenu name="3">
          <template slot="title">
            <span
              @click="handleClickLinkRedteaGo"
              :class="{
                active: activeShow.RedteaGo,
                unactive: !activeShow.RedteaGo,
              }"
              >{{ $t("nav.RedteaGO") }}</span
            >
          </template>
          <MenuItem name="3-1" to="/RedteaGo#iosEsim">
            {{ $t("nav.iosEsim") }}
          </MenuItem>
          <MenuItem name="3-4" to="/RedteaGo#Pixel">
            {{ $t("nav.Pixel") }}
          </MenuItem>
          <!--          <MenuItem name="3-5" to="/RedteaGo#SIMCard">-->
          <!--            {{ $t("nav.GlobalSIM") }}-->
          <!--          </MenuItem>-->
          <MenuItem name="3-2" to="/RedteaGo#Android">
            {{ $t("nav.Android") }}
          </MenuItem>
        </Submenu>
        <Submenu name="4">
          <template slot="title">
            <span
              @click="handleClickLinkRedteaReady"
              :class="{
                active: activeShow.RedteaReady,
                unactive: !activeShow.RedteaReady,
              }"
              >{{ $t("nav.RedteaReady") }}</span
            >
          </template>
          <MenuItem name="4-2" to="/RedteaReady#FWA">
            {{ $t("nav.Fixed") }}
          </MenuItem>
          <MenuItem name="4-3" to="/RedteaReady#Automotive">
            {{ $t("nav.Automotive") }}
          </MenuItem>
          <MenuItem name="4-4" to="/RedteaReady#Handheld">
            {{ $t("nav.Handheld") }}
          </MenuItem>
          <MenuItem name="4-5" to="/RedteaReady#Logistcs">
            {{ $t("nav.Logistcs") }}
          </MenuItem>
          <MenuItem name="4-6" to="/RedteaReady#Utilities">
            {{ $t("nav.Utilities") }}
          </MenuItem>
          <MenuItem name="4-7" to="/RedteaReady#Wearable">
            {{ $t("nav.Dongle") }}
          </MenuItem>
        </Submenu>
        <Submenu name="9">
          <template slot="title">
            <span
              @click="handleClickLinkRedteaSIM"
              :class="{
                active: activeShow.RedteaSIM,
                unactive: !activeShow.RedteaSIM,
              }"
              >{{ $t("nav.eSIM") }}</span
            >
          </template>
          <MenuItem name="9-2" to="/RedteaSIM#cost">
            {{ $t("nav.cost") }}
          </MenuItem>
          <MenuItem name="9-3" to="/RedteaSIM#Improve">
            {{ $t("nav.Improve") }}
          </MenuItem>
          <MenuItem name="9-4" to="/RedteaSIM#exp">
            {{ $t("nav.exp") }}
          </MenuItem>
        </Submenu>
        <MenuItem name="eSimPlus">
          <span
            @click="handleClickLinkESimPlus"
            :class="{
              active: activeShow.esimPlus,
              unactive: !activeShow.esimPlus,
            }"
            >{{ $t("nav.eSimPlus") }}</span
          >
        </MenuItem>
        <Submenu name="2">
          <template slot="title">
            <span
              @click="handleClickLinkCaaS"
              :class="{
                active: activeShow.CaaS,
                unactive: !activeShow.CaaS,
              }"
              >{{ $t("nav.CaaS") }}</span
            >
          </template>
          <MenuItem name="2-1" to="/CaaS#Global">
            {{ $t("nav.Global") }}
          </MenuItem>
          <MenuItem name="2-2" to="/CaaS#Embedded">
            {{ $t("nav.Embedded") }}
          </MenuItem>
          <MenuItem name="2-3" to="/CaaS#Open">{{ $t("nav.Open") }}</MenuItem>
          <MenuItem name="2-4" to="/CaaS#Smart">{{ $t("nav.Smart") }}</MenuItem>
        </Submenu>
        <Submenu name="6">
          <template slot="title">
            <span
              @click="handleClickLinkResources"
              :class="{
                active: activeShow.Resources,
                unactive: !activeShow.Resources,
              }"
              >{{ $t("nav.Resources") }}</span
            >
          </template>
          <MenuItem name="6-1" to="/Resources#News">
            {{ $t("nav.NewsEvents") }}
          </MenuItem>
          <MenuItem name="6-2" to="/Resources#Industry">
            {{ $t("nav.IndustryReports") }}
          </MenuItem>
          <MenuItem name="6-3" to="/Resources#Insights">
            {{ $t("nav.Insights") }}
          </MenuItem>
          <MenuItem name="6-4" to="/Resources#Terms">
            {{ $t("nav.TermsJargons") }}
          </MenuItem>
          <MenuItem name="6-5" to="/Resources#FAQ">
            {{ $t("nav.FAQ") }}
          </MenuItem>
        </Submenu>
        <Submenu name="7">
          <template slot="title">
            <span
              @click="handleClickLinkAboutUs"
              :class="{
                active: activeShow.about,
                unactive: !activeShow.about,
              }"
              >{{ $t("nav.AboutUs") }}</span
            >
          </template>
          <MenuItem name="7-1" to="/about#Overview">
            {{ $t("nav.Overview") }}
          </MenuItem>
          <MenuItem name="7-2" to="/about#Mission">
            {{ $t("nav.Mission") }}
          </MenuItem>
          <MenuItem name="7-3" to="/about#Vision">
            {{ $t("nav.Vision") }}
          </MenuItem>
          <MenuItem name="7-4" to="/about#Values">
            {{ $t("nav.Values") }}
          </MenuItem>
          <MenuItem name="7-5" to="/about#Recognition">
            {{ $t("nav.Recognition") }}
          </MenuItem>
          <MenuItem name="7-6" to="/about#Careers">
            {{ $t("nav.Careers") }}
          </MenuItem>
          <MenuItem name="7-7" to="/about#Team">{{ $t("nav.Team") }}</MenuItem>
        </Submenu>
        <MenuItem name="8" to="/Contact">
          <span
            @click="handleClickLinkContact"
            :class="{
              active: activeShow.Contact,
              unactive: !activeShow.Contact,
            }"
            >{{ $t("nav.ContactUs") }}</span
          >
        </MenuItem>
      </Menu>
    </div>
    <!-- web咨询模态框 -->
    <Modal
      v-model="modal11"
      footer-hide
      width="80"
      class="web-enquiry"
      @on-visible-change="clear"
    >
      <Row>
        <Col span="24" class="modal-title">{{ $t("enquiryBox.title") }}</Col>
      </Row>
      <Row>
        <Col span="24" class="modal-des">{{ $t("enquiryBox.des") }}</Col>
      </Row>
      <Row>
        <Col class="modal-line"></Col>
      </Row>
      <Row style="margin-top: 0.55rem; margin-bottom: 0.2rem">
        <Col span="12" class="left-box">
          <div class="nav-help">
            <p class="help-title">{{ $t("enquiryBox.left.title1") }}</p>
            <div class="help-content">
              <img src="../assets/web/对号.svg" />
              {{ $t("enquiryBox.left.text1") }}
            </div>
            <div class="help-content">
              <img src="../assets/web/对号.svg" />
              {{ $t("enquiryBox.left.text2") }}
            </div>
            <div class="help-content">
              <img src="../assets/web/对号.svg" />
              {{ $t("enquiryBox.left.text3") }}
            </div>
            <div class="help-content">
              <img src="../assets/web/对号.svg" />
              {{ $t("enquiryBox.left.text4") }}
            </div>
          </div>
          <div class="nav-email">
            <p class="help-title">{{ $t("enquiryBox.left.title2") }}</p>
            <p class="email-des help-content">
              {{ $t("enquiryBox.left.text5") }}
            </p>
            <a href="mailto:support@redteamobile.net" class="email-name">
              {{ $t("enquiryBox.left.text6") }}
            </a>
            <p class="email-des help-content">
              {{ $t("enquiryBox.left.text7") }}
            </p>
            <a
              href="mailto:communications@redteamobile.com"
              class="email-name"
              >{{ $t("enquiryBox.left.text8") }}</a
            >
          </div>
          <div class="nav-find">
            <p class="help-title">{{ $t("enquiryBox.left.title3") }}:</p>
            <Poptip trigger="hover" placement="top">
              <img
                src="../assets/web/微信.svg"
                style="margin-left: -0.1rem; width: 0.68rem"
              />
              <div slot="content">
                <img
                  src="../assets/web/红茶移动微信二维码.jpg"
                  style="width: 150px"
                />
              </div>
            </Poptip>
            <a href="https://www.facebook.com/redteamobile" target="_Blank">
              <img
                src="../assets/web/Facebook.svg"
                style="margin-left: -0.08rem"
              />
            </a>
            <a href="https://twitter.com/redteamobile" target="_Blank">
              <img src="../assets/web/Twitter.svg" />
            </a>
            <a
              href="https://www.linkedin.com/company/13216053/"
              target="_Blank"
            >
              <img src="../assets/web/Linkedin.svg" />
            </a>
            <a
              href="https://www.zhihu.com/org/redteamobile/activities"
              target="_Blank"
            >
              <img src="../assets/web/知乎.svg" />
            </a>
          </div>
        </Col>
        <Col span="12" class="right-box">
          <Form
            ref="formEnquiry"
            :model="formEnquiry"
            :rules="ruleValidate"
            :show-message="false"
          >
            <FormItem>
              <Input
                v-model="formEnquiry.name"
                :placeholder="$t('enquiryBox.right.text1')"
                style="width: 75%"
              />
            </FormItem>
            <FormItem prop="businessEmail">
              <Input
                v-model="formEnquiry.businessEmail"
                :placeholder="$t('enquiryBox.right.text2')"
                style="width: 75%"
              />
            </FormItem>
            <FormItem>
              <Input
                v-model="formEnquiry.company"
                :placeholder="$t('enquiryBox.right.text3')"
                style="width: 75%"
              />
            </FormItem>
            <FormItem>
              <Input
                v-model="formEnquiry.phoneNumber"
                :placeholder="$t('enquiryBox.right.text4')"
                style="width: 75%"
              />
            </FormItem>
            <FormItem>
              <Input
                v-model="formEnquiry.help"
                :placeholder="$t('enquiryBox.right.text5')"
                style="width: 75%"
              />
            </FormItem>
          </Form>
          <div class="confirm-btn" @click="send">
            {{ $t("enquiryBox.hear") }}
          </div>
        </Col>
      </Row>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "nav-header-web",
  data() {
    return {
      theme1: "light",
      value: "",
      modal11: false,
      formEnquiry: {
        name: "",
        businessEmail: "",
        company: "",
        phoneNumber: "",
        help: "",
      },
      ruleValidate: {
        businessEmail: [
          {
            required: true,
            message: this.$t("mail1"),
            trigger: "blur",
          },
          {
            pattern:
              /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/,
            message: this.$t("mail2"),
            trigger: "blur",
          },
        ],
      },
      flag: true,
      activeShow: {
        home: false,
        RedteaGo: false,
        RedteaReady: false,
        CaaS: false,
        Resources: false,
        about: false,
        Contact: false,
        esimPlus: false,
      },
    };
  },
  created() {
    this.flag = this.$i18n.locale === "en";
    let url = document.location.toString();
    let arrUrl = url.split("/");
    let para = arrUrl[arrUrl.length - 1];
    this.activeShow[para] = true;
  },
  watch: {
    "$route.path": {
      handler(newVal) {
        switch (newVal) {
          case "/":
            this.handleActiveNavBar("home");
            break;
          case "/RedteaGo":
            this.handleActiveNavBar("RedteaGo");
            break;
          case "/RedteaReady":
            this.handleActiveNavBar("RedteaReady");
            break;
          case "/RedteaSIM":
            this.handleActiveNavBar("RedteaSIM");
            break;
          case "/esim-plus":
            this.handleActiveNavBar("esimPlus");
            break;
          case "/CaaS":
            this.handleActiveNavBar("CaaS");
            break;
          case "/Resources":
            this.handleActiveNavBar("Resources");
            break;
          case "/about":
            this.handleActiveNavBar("about");
            break;
          case "/Contact":
            this.handleActiveNavBar("Contact");
            break;
          default:
            break;
        }
      },
    },
  },
  methods: {
    clear(flag) {
      if (!flag) {
        this.formEnquiry.name = "";
        this.formEnquiry.businessEmail = "";
        this.formEnquiry.company = "";
        this.formEnquiry.phoneNumber = "";
        this.formEnquiry.help = "";
      }
    },
    send() {
      let param = this.formEnquiry;
      this.$refs.formEnquiry.validate((valid) => {
        if (valid) {
          this.$Message.success(this.$t("success"));
          this.$api.api.enquiry({ ...param, site: 1 }).then((res) => {
            this.modal11 = false;
          });
        } else {
          if (this.formEnquiry.businessEmail) {
            this.$Message.error(this.$t("mail2"));
          } else {
            this.$Message.error(this.$t("mail1"));
          }
        }
      });
    },
    handleSwitch() {
      window.open("https://www.redteamobile.com//", "_blank");
    },
    handleActiveNavBar(name) {
      this.activeShow.home = false;
      this.activeShow.RedteaGo = false;
      this.activeShow.RedteaReady = false;
      this.activeShow.CaaS = false;
      this.activeShow.Resources = false;
      this.activeShow.about = false;
      this.activeShow.Contact = false;
      this.activeShow.RedteaSIM = false;
      this.activeShow.esimPlus = false;
      this.activeShow[name] = true;
    },
    handleClickLinkHome() {
      this.handleActiveNavBar("home");
    },
    handleClickLinkRedteaGo() {
      if (this.$route.path === "/RedteaGo") return;
      this.$router.push({
        path: "/RedteaGo",
      });
      this.handleActiveNavBar("RedteaGo");
    },
    handleClickLinkRedteaReady() {
      if (this.$route.path === "/RedteaReady") return;
      this.$router.push({
        path: "/RedteaReady",
      });
      this.handleActiveNavBar("RedteaReady");
    },
    handleClickLinkCaaS() {
      if (this.$route.path === "/CaaS") return;
      this.$router.push({
        path: "/CaaS",
      });
      this.handleActiveNavBar("CaaS");
    },
    handleClickLinkResources() {
      if (this.$route.path === "/Resources") return;
      this.$router.push({
        path: "/Resources",
      });
      this.handleActiveNavBar("Resources");
    },
    handleClickLinkAboutUs() {
      if (this.$route.path === "/about") return;
      this.$router.push({
        path: "/about",
      });
      this.handleActiveNavBar("about");
    },
    handleClickLinkRedteaSIM() {
      if (this.$route.path === "/RedteaSIM") return;
      this.$router.push({
        path: "/RedteaSIM",
      });
      this.handleActiveNavBar("RedteaSIM");
    },
    handleClickLinkContact() {
      if (this.$route.path === "/Contact") return;
      this.$router.push({
        path: "/Contact",
      });
      this.handleActiveNavBar("Contact");
    },
    handleClickLinkESimPlus() {
      if (this.$route.path === "/esim-plus") return;
      this.$router.push({
        path: "/esim-plus",
      });
      this.handleActiveNavBar("esimPlus");
    },
  },
};
</script>
<style lang="less">
.web-iphone {
  .ivu-modal-body {
    padding-bottom: 0px !important;
  }

  .modal-title {
    font-family: "Poppins-Bold";
    font-size: 0.56rem;
    color: rgba(32, 49, 82, 1);
    text-align: center;
    margin: 0.5rem auto 0.6rem auto;
    padding: 0 25%;
  }

  .modal-line {
    width: 95%;
    height: 1px;
    border-bottom: 1px solid rgba(218, 218, 218, 1);
    margin: auto;
  }

  .iphone-title-2 {
    font-family: "Poppins-SemiBold";
    font-size: 0.24rem;
    color: rgba(32, 49, 82, 1);
    margin-bottom: 0.2rem;
    margin-left: -10px;
    width: 4.1rem;
  }

  .iphone-lists {
    width: 4.7rem;
    font-family: "Poppins-Regular";
    font-size: 0.2rem;
    color: rgba(32, 49, 82, 0.79);
    margin-bottom: 0.1rem;
    position: relative;
  }

  .iphone-lists::before {
    position: absolute;
    left: -10px;
    top: 0px;
    content: "-";
  }

  .iphone-bottom {
    font-family: "Poppins-Regular";
    font-size: 0.2rem;
    margin-top: 1.2rem;
  }

  .web-iphone-box {
    margin-top: 0.6rem;
    height: 4.9rem;
    position: relative;
  }

  .mobile-img {
    width: 4.8rem;
    height: auto;
    position: absolute;
    bottom: 0;
    left: -16px;
  }

  .down-img {
    width: 1.2rem;
    height: auto;
    margin-top: 10px;
    cursor: pointer;
    margin-left: 4rem;
  }

  .more {
    margin-top: 0.4rem;
    font-family: "Poppins-Regular";
    font-size: 0.2rem;
    color: rgba(255, 255, 255, 1);
    background: rgba(32, 49, 82, 0.99);
    border-radius: 10px;
    padding: 0.11rem 0;
    width: 2rem;
    text-align: center;
    cursor: pointer;
  }
}

.web-enquiry {
  .modal-title {
    color: rgba(32, 49, 82, 1);
    font-family: "Poppins-Light";
    font-size: 50px;
    line-height: 0.76rem;
    text-align: center;
    margin: 0.2rem auto 0.1rem auto;
  }

  .modal-des {
    color: rgba(32, 49, 82, 1);
    font-family: Poppins-ExtraLight;
    font-size: 20px;
    line-height: 0.3rem;
    text-align: center;
    margin-bottom: 0.6rem;
  }

  .modal-line {
    width: 80%;
    height: 1px;
    border-bottom: 1px solid rgba(218, 218, 218, 1);
    margin: auto;
  }

  .left-box {
    padding: 0.4rem 0 0.4rem 10%;
    border-right: 1px solid rgba(218, 218, 218, 1);
  }

  .right-box {
    padding-left: 5%;
    padding-top: 0.4rem;
  }

  .nav-help {
  }

  .help-title {
    color: rgba(32, 49, 82, 1);
    font-size: 16px;
    line-height: 0.25rem;
    margin-bottom: 0.15rem;
  }

  .help-content {
    color: rgba(32, 49, 82, 1);
    font-family: "Poppins-Light";
    font-size: 12px;
    line-height: 0.18rem;
    margin-top: 0.1rem;

    img {
      margin-right: 0.1rem;
    }
  }

  .email-name {
    color: rgba(207, 42, 42, 1);
    font-family: "Poppins-Light";
    font-size: 12px;
    margin-bottom: 0.05rem;
  }

  .nav-email {
    padding-top: 0.4rem;
  }

  .nav-find {
    padding-top: 0.5rem;

    img {
      width: 0.58rem;
    }
  }

  .confirm-btn {
    width: 3.28rem;
    height: 0.8rem;
    background-color: rgba(207, 42, 42, 1);
    cursor: pointer;
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
    text-align: center;
    line-height: 0.8rem;
    margin: 10% 0 0 15%;
    font-family: "Poppins-Regular";
  }

  .ivu-form-item {
    margin-bottom: 0 !important;
  }

  @media screen and (min-width: 798px) {
    .ivu-form-item {
      margin-bottom: 0.3rem !important;
    }

    .confirm-btn {
      width: 2.28rem;
      height: 0.6rem;
      line-height: 0.6rem;
      margin: 15% 0 0 20%;
    }
  }
  @media screen and (min-width: 1441px) {
    .ivu-form-item {
      margin-bottom: 0.4rem !important;
    }

    .confirm-btn {
      width: 2.28rem;
      height: 0.6rem;
      line-height: 0.6rem;
      margin: 15% 0 0 20%;
    }
  }
}

.ivu-input {
  border: none !important;
  border-bottom: 1px solid rgba(140, 140, 140, 1) !important;
  border-radius: 0px !important;
  font-family: "Poppins-Light";
  font-size: 14px;
}

.ivu-input:focus {
  box-shadow: none !important;
}

.nav-header-web {
  .header {
    margin: 0.42rem auto 0.1rem auto;
    padding-bottom: 0.2rem;
    height: 100%;
    width: 18rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(32, 49, 82, 0.29);
    align-items: center;

    .logo-img {
      width: 1.66rem;
    }

    .header-des {
      color: rgba(207, 42, 42, 1);
      line-height: 0.3rem;
      font-family: "Poppins-ExtraLight";
      font-size: 20px;
      margin-left: 0.3rem;
    }

    .enquiry {
      font-size: 16px;
      color: rgba(32, 49, 82, 1);
      margin-right: 0.5rem;
    }

    .lang-btn {
      font-size: 16px;
      color: rgba(32, 49, 82, 1);
    }
  }

  .menu {
    display: flex;
    justify-content: center;
  }

  .active {
    color: #cf2a2a;
  }

  .unactive {
    color: #203152;
  }
}
</style>